'use client';

import { type ProductVideo } from '@/domain/products/types';
import { toDateString } from '@/utils/datetime';
import { Fragment } from 'react';
import YouTube, { type YouTubeProps } from 'react-youtube';

import styles from '../Overview.module.scss';

interface VideoSectionProps {
  videos: ProductVideo[];
}

const sortVideos = (a: ProductVideo, b: ProductVideo) => {
  if (!a.timestamp && !b.timestamp) {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
  }
  if (!a.timestamp) return 1;
  if (!b.timestamp) return -1;
  if (a.timestamp > b.timestamp) return -1;
  if (a.timestamp < b.timestamp) return 1;
  if (a.title < b.title) return -1;
  if (a.title > b.title) return 1;
  return 0;
};

const opts: YouTubeProps['opts'] = {
  height: '360',
  width: '640',
};

const VideoSection = ({ videos }: VideoSectionProps) => (
  <>
    <h4 className={styles.title}>Videos</h4>
    <div className={styles.container}>
      {[...videos].sort(sortVideos).map((video) => {
        const videoId = video.hyperlink.split('v=')[1] ?? video.hyperlink.split('embed/')[1];
        return (
          <Fragment key={video.idProductVideo}>
            <div>
              <b>{video.title}</b>
              <p className={styles.videoDate}>{video.timestamp && toDateString(video.timestamp, '-')}</p>
            </div>
            <div className={styles.videoContainer}>
              <YouTube loading="lazy" opts={opts} videoId={videoId} title={video.title} />
            </div>
          </Fragment>
        );
      })}
    </div>
  </>
);

export default VideoSection;
